if (!customElements.get('sotto-product-hero')) {
  customElements.define(
    'sotto-product-hero',
    class SottoProductHero extends HTMLElement {
      constructor() {
        super();
        this.requiredStyles = parseInt(this.dataset.requiredStyles || '3', 10);
        this.enforceStyles = this.hasAttribute('data-enforce-styles');
        this.styleInputs = Array.from(this.querySelectorAll('[data-sotto-style]'));
        this.stylesProperty = this.querySelector('[data-sotto-styles-property]');
        this.styleCount = this.querySelector('[data-sotto-style-count]');
        this.submitButton = this.querySelector('[data-sotto-submit]');
        this.submitLabel = this.querySelector('[data-sotto-submit-label]');
        this.priceOutput = this.querySelector('[data-sotto-price]');
        this.priceSuffix = this.querySelector('[data-sotto-price-suffix]');
        this.planInputs = Array.from(this.querySelectorAll('input[name="selling_plan"]'));
        this.variantSelect = this.querySelector('[data-sotto-variant-select]');
        this.variantIdInput = this.querySelector('input.product-variant-id');
        this.mainMedia = this.querySelector('[data-sotto-main-media]');
        this.thumbs = Array.from(this.querySelectorAll('[data-sotto-thumb]'));
      }

      connectedCallback() {
        this.styleInputs.forEach((input) => {
          input.addEventListener('change', () => this.onStyleChange(input));
        });

        this.planInputs.forEach((input) => {
          input.addEventListener('change', () => this.updatePrice());
        });

        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', () => {
            if (this.variantIdInput) this.variantIdInput.value = this.variantSelect.value;
          });
        }

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.swapMedia(thumb));
        });

        this.applyQuizResult();
        this.syncStyles();
        this.updatePrice();
      }

      applyQuizResult() {
        if (this.styleInputs.length === 0) return;
        let saved = null;
        try {
          saved = localStorage.getItem('sotto_quiz_result');
        } catch (error) {
          return;
        }
        if (!saved) return;
        const anyChecked = this.styleInputs.some((input) => input.checked);
        if (anyChecked) return;
        const match = this.styleInputs.find(
          (input) => input.value.toLowerCase() === saved.toLowerCase()
        );
        if (match) match.checked = true;
      }

      onStyleChange(input) {
        const checkedCount = this.styleInputs.filter((item) => item.checked).length;
        if (input.checked && checkedCount > this.requiredStyles) {
          input.checked = false;
          return;
        }
        this.syncStyles();
      }

      syncStyles() {
        const selected = this.styleInputs.filter((input) => input.checked).map((input) => input.value);

        if (this.stylesProperty) this.stylesProperty.value = selected.join(', ');

        if (this.styleCount) {
          this.styleCount.textContent = this.styleInputs.length
            ? `${selected.length}/${this.requiredStyles}`
            : '';
        }

        this.styleInputs.forEach((input) => {
          input.closest('.sotto-style-option').classList.toggle('is-checked', input.checked);
        });

        if (this.enforceStyles && this.styleInputs.length > 0 && this.submitButton) {
          const complete = selected.length === this.requiredStyles;
          const soldOut = this.submitButton.dataset.soldOut === 'true';
          if (!soldOut) {
            this.submitButton.disabled = !complete;
            this.updateSubmitLabel(complete);
          }
        }
      }

      updateSubmitLabel(complete) {
        if (!this.submitLabel || !this.submitButton) return;
        if (this.submitButton.dataset.soldOut === 'true') return;
        if (!complete && this.submitButton.dataset.selectLabel) {
          this.submitLabel.textContent = this.submitButton.dataset.selectLabel;
          return;
        }
        let label = this.submitButton.dataset.addLabel || this.submitLabel.textContent;
        if (this.submitButton.dataset.showPrice === 'true') {
          const price = this.currentPriceFormatted();
          if (price) label = `${label} — ${price}`;
        }
        this.submitLabel.textContent = label;
      }

      currentPriceFormatted() {
        const checkedPlan = this.planInputs.find((input) => input.checked);
        if (checkedPlan) return checkedPlan.dataset.priceFormatted;
        if (this.priceOutput) return this.priceOutput.textContent.trim();
        return '';
      }

      updatePrice() {
        const checkedPlan = this.planInputs.find((input) => input.checked);
        if (checkedPlan && this.priceOutput) {
          this.priceOutput.textContent = checkedPlan.dataset.priceFormatted;
          if (this.priceSuffix) {
            this.priceSuffix.hidden = checkedPlan.dataset.showSuffix !== 'true';
          }
        }
        const complete =
          !this.enforceStyles ||
          this.styleInputs.length === 0 ||
          this.styleInputs.filter((input) => input.checked).length === this.requiredStyles;
        this.updateSubmitLabel(complete);
      }

      swapMedia(thumb) {
        if (!this.mainMedia) return;
        const image = this.mainMedia.querySelector('img');
        if (!image) return;
        image.src = thumb.dataset.mediaUrl;
        image.removeAttribute('srcset');
        this.thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    }
  );
}
